import Typography from 'components/curo-components/common/Typography';

import styles from './HowToMakePayments.module.scss';

const MY_ACCOUNT_LINK = 'https://myaccount.heightsfinance.com/#/home/login';

const paymentsSteps = [
  {
    key: 1,
    title: 'AutoPay',
    text: (
      <>
        Log into{' '}
        <a href={MY_ACCOUNT_LINK} target="_blank" rel="noopener noreferrer" className={styles.link}>
          MyAccount
        </a>
      </>
    ),
  },
  {
    key: 2,
    title: 'Pay Online',
    text: (
      <>
        Online{' '}
        <a href={MY_ACCOUNT_LINK} target="_blank" rel="noopener noreferrer" className={styles.link}>
          Payment Center
        </a>
      </>
    ),
  },
  {
    key: 3,
    title: 'Pay at Branch',
    text: 'By ACH, check, money order or debit card.',
  },
];

const HowToMakePayments = () => {
  return (
    <div>
      <div className={styles.subHeader}>How to make payments:</div>
      <div className={styles.itemsWrapper}>
        {paymentsSteps.map((step) => (
          <div key={step.key} className={styles.itemContainer}>
            <div className={styles.gradient} />
            <div className={styles.circle}>{step.key}</div>
            <div className={styles.itemTitle}>{step.title}</div>
            <div className={styles.itemText}>{step.text}</div>
          </div>
        ))}
      </div>
      <div className={styles.footerWrapper}>
        <div className={styles.footerText}>*</div>
        <Typography className={styles.footerText}>
          Payment option not available in all states. GA, MO, AL, TX, and TN customers: We may
          charge a non-refundable Convenience Fee for the convenience of making payments through
          alternate payment methods such as PayPal and Venmo or by debit card. A Convenience Fee is
          not charged for in-store payments made via Automated Clearing House ("ACH"), or payments
          by check or money order. OK Customers Only: A non-refundable transaction fee may be
          applied to payments over $75.00.
        </Typography>
      </div>
    </div>
  );
};

export default HowToMakePayments;
